import { Fragment, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { connect } from "react-redux";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import ShopProduct from "../../components/ShopProduct";
import { getProducts } from "../../api/product";
import Footer from "../../components/footer/Footer";
import CtaSection from "../../components/ctaSection/ctaSection";
import Navbar2 from "../../components/Navbar2/Navbar2";
import img from "../../images/product-page-title.jpg";
import StarLoader from "../../components/loader/StarLoader";

const ShopPage = () => {
  const [filteredProducts, setFilteredProducts] = useState([]);

  const location = useLocation(); // 👈 gives access to URL query
  const queryParams = new URLSearchParams(location.search);
  const categoryId = queryParams.get("category_id"); // 👈 extract ?category_id=...
  const categoryName = queryParams.get("category_name");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    async function loadProducts() {
      setLoading(true);
      try {
        const data = await getProducts({ categoryId });
        if (isMounted) {
          setFilteredProducts(data);
        }
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        if (isMounted) setLoading(false);
      }
    }

    loadProducts();

    return () => {
      isMounted = false; // cleanup to prevent setState after unmount
    };
  }, [categoryId]);

  // 👇 Show loader while loading is true, else show the full page
  if (loading) {
    return <StarLoader />;
  }

  if (!filteredProducts.length)
    return (
      <p style={{ textAlign: "center", padding: "50px" }}>
        No products found for this category.
      </p>
    );

  return (
    <Fragment>
      <Navbar2 hclass={"wpo-header-style-1"} />
      <PageTitle pageTitle={"Product"} pagesub={"Product"} img={img} />
      <section
        className="wpo-shop-page section-padding"
        style={{
          backgroundColor: "#E6F7FF",
          paddingTop: "40px", // reduce vertical padding
          paddingBottom: "40px", // reduce vertical padding
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center mb-4">
              <h2
                style={{
                  fontSize: "28px",
                  fontWeight: "600",
                  color: "#222",
                  textTransform: "capitalize",
                }}
              >
                {categoryName ? (
                  <>
                    Products In Category{" "}
                    <span
                      style={{
                        color: "#007BFF",
                        fontWeight: "700",
                        borderBottom: "3px solid #007BFF",
                        paddingBottom: "2px",
                        marginLeft: "5px",
                      }}
                    >
                      {categoryName}
                    </span>
                  </>
                ) : (
                  "Products In All Categories"
                )}
              </h2>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <ShopProduct products={filteredProducts} />
            </div>
          </div>
        </div>
      </section>
      <CtaSection />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default ShopPage;
